var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters-ctn"},_vm._l((_vm.generatedFilters),function(singleFilter,index){return _c('filter-group',{key:index,attrs:{"title":singleFilter.label,"options":singleFilter.values,"disabled":_vm.disabled},on:{"filterClick":(key, value) => _vm.selectFilter(singleFilter.key, key, value)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }